import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { redux } from '../reduxService';
import reportWebVitals from '../reportWebVitals';
import App from './App';
import './index.scss';
import './style/base.scss';
import { BrowserRouter } from 'react-router-dom';

const container = document.getElementById('root');
const root = createRoot(container!);

//console.log("MacRo FE - V."+process.env.REACT_APP_VERSION);

root.render(
    <Provider store={redux}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
